import React, { createContext, useState, useContext, useEffect } from 'react';
import i18n from '../../i18n';
import tituloData from '../../data/tituloWeb.json'; // Importar el archivo JSON

export const IdiomaContext = createContext();

export const IdiomaProvider = ({ children }) => {
  const [idioma, setIdioma] = useState(() => {
    // Recuperar el idioma del almacenamiento local
    return localStorage.getItem('idioma') || 'es';
  });

  const cambiarIdioma = (nuevoIdioma) => {
    setIdioma(nuevoIdioma);
    i18n.changeLanguage(nuevoIdioma);
    // Guardar el idioma en el almacenamiento local
    localStorage.setItem('idioma', nuevoIdioma);
  };

  // Efecto para cambiar el título, la descripción, las palabras clave y el atributo lang de la página
  useEffect(() => {
    document.title = idioma === 'es' ? tituloData.tituloEs : tituloData.tituloEn; // Cambia según el idioma
    document.querySelector('meta[name="description"]').setAttribute('content', idioma === 'es' ? tituloData.descripcionEs : tituloData.descripcionEn); // Cambia la meta descripción
    document.querySelector('meta[name="keywords"]').setAttribute('content', idioma === 'es' ? tituloData.keywordsEs : tituloData.keywordsEn); // Cambia las palabras clave
    
    // Cambiar el atributo lang del HTML dinámicamente
    document.documentElement.lang = idioma;
  }, [idioma]);

  return (
    <IdiomaContext.Provider value={{ idioma, cambiarIdioma }}>
      {children}
    </IdiomaContext.Provider>
  );
};

export const useIdioma = () => useContext(IdiomaContext);